import React, { FC } from 'react';

import { useTheme } from '../../util/theme';

import { getClassNames } from './LayoutList.styles';
import { LayoutListProps } from './LayoutList.types';
import LayoutListIsPresentationalContext from './LayoutListIsPresentationalContext';

/**
 * A `LayoutList` displays a list of items either horizontally or vertical. Horizontal list items
 * are evenly spaced with a fixed margin of 4px, and can be aligned to the right or left. Vertical
 * list items do not have any margin.
 */
const LayoutList: FC<LayoutListProps> = ({
  children,
  className,
  direction,
  itemSpacing,
  showSeparator,
  separatorColor = 'neutralLighter',
  align = 'left',
  preventItemWrap,
  fitToContent,
  isPresentational = false,
}) => {
  const theme = useTheme();
  const classNames = getClassNames({
    direction,
    fitToContent,
    itemSpacing,
    align,
    preventItemWrap,
    theme,
    showSeparator,
    separatorColor,
    className,
  });

  const ListElement = isPresentational ? 'div' : 'ul';

  return (
    <LayoutListIsPresentationalContext.Provider value={isPresentational}>
      <ListElement className={classNames.layoutList}>{children}</ListElement>
    </LayoutListIsPresentationalContext.Provider>
  );
};

export default LayoutList;
